// 开发环境
if (process.env.NODE_ENV === "development") {
  window.baseURL = "https://tower.realsun.me";
  // 生产环境
} else {
  window.baseURL = "https://tower.realsun.me";

}
